export default __webpack_public_path__ + "static/media/476.ea3ced4a.png";